export default "__VITE_ASSET__BbURWsnM__"